import { genPaginationLabels, calcCurrentPage, calcIfNextPagePossible, calcIfPreviousPagePossible } from './utils';
import { useMemo } from 'react';
export const usePagination = (count, offset, limit, padding = 2) => useMemo(() => {
    const paginationLabels = genPaginationLabels(count, offset, limit, padding);
    const currentPage = calcCurrentPage(offset, limit);
    const isNextPagePossible = calcIfNextPagePossible(count, offset, limit);
    const isPreviousPagePossible = calcIfPreviousPagePossible(offset);
    const shouldShowPager = limit < count;
    return {
        paginationLabels,
        currentPage,
        isNextPagePossible,
        isPreviousPagePossible,
        shouldShowPager
    };
}, [count, offset, limit, padding]);
export default usePagination;
//# sourceMappingURL=index.js.map